import { LocalizationTargetType } from '../enums/LocalizationTargetType';

export class LocalContent<LocalContentType> {
	public constructor(
		public readonly target: LocalizationTargetType,
		public readonly content: LocalContentType,
		public readonly countryIso: string | null = null,
		public readonly countryId: number | null = null
	) {}
}
